/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%] > div[_ngcontent-%COMP%]{display:flex;align-items:center;justify-items:center}[_nghost-%COMP%]   mat-select[_ngcontent-%COMP%]{width:80%}[_nghost-%COMP%]   label[_ngcontent-%COMP%]{font-size:8pt;color:#778899}[_nghost-%COMP%]   .item[_ngcontent-%COMP%]{display:flex;flex-direction:column;align-items:center;flex:auto;border-right:1px solid #d3d3d3}[_nghost-%COMP%]   .item[_ngcontent-%COMP%]:first-of-type{border-left:1px solid #d3d3d3}"];
export { styles as styles };
